import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSelectGroup,
  DropdownMenuSelectItem,
  DropdownMenuTrigger,
  Icon,
} from "@coreai/component-library";
import { useLanguage, LANGUAGE_STORAGE_KEY } from "../../../LanguageContext";
import { useTheme } from "@emotion/react";
import ConfirmModal from "components/CommonUi/ConfirmModal/ConfirmModal";
import { useState } from "react";

type LanguageCode = "en" | "fr";
const LanguageDropdown: React.FC = ({}) => {
  const { t, setLanguage, language } = useLanguage();
   const theme = useTheme();
   const [showDialog, setShowDialog] = useState(false);
   const [langVal, setLangVal] = useState<LanguageCode>();

  const handleLanguageChange = (localeCode: LanguageCode) => {
    setLanguage(localeCode);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, localeCode);
  };

  const handleOpenModal = (isOpen: boolean, localeCode: LanguageCode) => {
    setShowDialog(isOpen);
    setLangVal(localeCode);
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <div
            style={{
              display: "flex",
              gap: theme.spacing.sm,
              fontWeight: theme.typography.body_semiBold.fontWeight,
              fontSize: theme.typography.body_semiBold.fontSize,
              color: theme.colors.textMedium,
            }}
          >
            <Icon name="globe" size="sm" />
            {language == "en" ? "EN" : "FR"}
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent style={{ zIndex: 1000 }}>
          <DropdownMenuSelectGroup value={useLanguage.name}>
            <DropdownMenuSelectItem
              value="Fr"
              onClick={() => (window?.isAnalysisDescFilled && language !== "fr") ? handleOpenModal(true, "fr") : handleLanguageChange("fr")}
            >
              FR
            </DropdownMenuSelectItem>
            <DropdownMenuSelectItem
              value="En"
              onClick={() => (window?.isAnalysisDescFilled && language !== "en") ? handleOpenModal(true, "en") : handleLanguageChange("en")}
            >
              EN
            </DropdownMenuSelectItem>
          </DropdownMenuSelectGroup>
        </DropdownMenuContent>
      </DropdownMenu>
      <ConfirmModal
        open={showDialog && window?.isAnalysisDescFilled}
        onClose={() => setShowDialog(false)}
        onOk={() => {langVal && handleLanguageChange(langVal)}}
        title={t("confirm_modal_title", { modal_title: t("label_language") })}
        message={t("confirm_modal_desc", { modal_desc: langVal == "en" ? t("label_english") : t("label_french") })}
      />
    </>
  );
};

export default LanguageDropdown;
